import { Badge } from '@/components/shadcn/badge'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { RestSchemas } from '@/contexts/QueryProvider'
import { IconCircleCheckmarkOutline } from '@icons/IconCircleCheckmarkOutline'
import { IconCircleDeleteOutline } from '@icons/IconCircleDeleteOutline'
import { IconWarningOutline } from '@icons/IconWarningOutline'
import { Fragment } from 'react/jsx-runtime'

type MessagesPlatformStatusItem = RestSchemas['Messages.Platform.StatusItem']

const statusMap = {
  Check: { Icon: IconCircleCheckmarkOutline, color: 'text-green-500' },
  Warn: { Icon: IconWarningOutline, color: 'text-yellow-500' },
  Problem: { Icon: IconCircleDeleteOutline, color: 'text-red-500' },
}

export function ConnectionStatus({ connectionStatus }: { connectionStatus: MessagesPlatformStatusItem[] }) {
  return (
    <div className="flex items-center gap-3 text-sm">
      {/* <span className="font-light italic">Connection Status:</span> */}
      {connectionStatus.map((status) => {
        const { Icon, color } = statusMap[status.icon as keyof typeof statusMap]
        const message = status.messages
        const name = status.name
        const item = (
          <Badge variant="outline" className="flex h-7 items-center gap-2 bg-background">
            <Icon className={color} size={20} />
            <div>{name}</div>
          </Badge>
        )
        return message ? (
          <TooltipButton tooltip={<div className="max-w-[768px] whitespace-pre-wrap p-3">{message}</div>} key={name}>
            {item}
          </TooltipButton>
        ) : (
          <Fragment key={name}>{item}</Fragment>
        )
      })}
    </div>
  )
}
